import { render } from "./DetailsModal.vue?vue&type=template&id=b1c89162&scoped=true"
import script from "./DetailsModal.vue?vue&type=script&lang=js"
export * from "./DetailsModal.vue?vue&type=script&lang=js"

import "./DetailsModal.vue?vue&type=style&index=0&id=b1c89162&scoped=true&lang=css"
import "./DetailsModal.vue?vue&type=style&index=1&id=b1c89162&lang=scss&scoped=true"

import exportComponent from "/Users/n0m4dz/workspace/projects/seeroo-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1c89162"]])

export default __exports__